import { useEffect, useState } from "react";

import {
  ButtonTab,
  Container,
  ContainerPages,
  Menu,
  OptionsContainer,
} from "./styles";
import { LoadingGif, LoadingOverlay } from "../../shared/styles/global.styles";
import loadSCGif from "../../assets/load_SC.gif";
import RelatorioMovimentacoes from "./RelatorioMovimentacoes/RelatorioMovimentacoes";
import RelatorioInadimplencia from "./RelatorioInadimplencia/RelatorioInadimplencia";
import { useAuth } from "../../AuthContext/AuthContext";
import { ModulosEnum } from "../../shared/enum/modulos.enum";
import { PermissoesEnum } from "../../shared/enum/permicao.enum";
import RelatorioBoletosPagosCaixa from "./RelatorioBoletosPagosCaixa/RelatorioBoletosPagosCaixa";
import DeclaracaoAnualContribuicaoVoluntaria from "./DeclaracaoAnualContribuicaoVoluntaria/DeclaracaoAnualContribuicaoVoluntaria";
import RelatorioRecebimentos from "./RelatorioRecebimentos/RelatorioRecebimentos";
import RelatorioComparacaoValoresDadosFinanceiros from "./RelatorioComparacaoValoresDadosFinanceiros/RelatorioComparacaoValoresDadosFinanceiros";

const RelatoriosGerenciais: React.FC = () => {
  const { checkPermission } = useAuth();
  const editRelatorioMovimentacoes = checkPermission(
    ModulosEnum.RELATORIO_MOVIMENTACOES,
    PermissoesEnum.ESCRITA
  );
  const readRelatorioMovimentacoes = checkPermission(
    ModulosEnum.RELATORIO_MOVIMENTACOES,
    PermissoesEnum.LEITURA
  );

  const editRelatorioRecebimentos = checkPermission(
    ModulosEnum.RELATORIO_RECEBIMENTOS,
    PermissoesEnum.ESCRITA
  );
  const readRelatorioRecebimentos = checkPermission(
    ModulosEnum.RELATORIO_RECEBIMENTOS,
    PermissoesEnum.LEITURA
  );

  const editRelatorioBoletos = checkPermission(
    ModulosEnum.RELATORIO_BOLETOS,
    PermissoesEnum.ESCRITA
  );
  const readRelatorioBoletos = checkPermission(
    ModulosEnum.RELATORIO_BOLETOS,
    PermissoesEnum.LEITURA
  );

  const editRelatorioInadimplencia = checkPermission(
    ModulosEnum.RELATORIO_INADIMPLENCIA,
    PermissoesEnum.ESCRITA
  );
  const readRelatorioInadimplencia = checkPermission(
    ModulosEnum.RELATORIO_INADIMPLENCIA,
    PermissoesEnum.LEITURA
  );

  const editDeclaracaoRecebimento = checkPermission(
    ModulosEnum.DECLARACAO_RECEBIMENTO,
    PermissoesEnum.ESCRITA
  );
  const readDeclaracaoRecebimento = checkPermission(
    ModulosEnum.DECLARACAO_RECEBIMENTO,
    PermissoesEnum.LEITURA
  );

  const editRelatorioComparacaoValoresDadosFinanceiros = checkPermission(
    ModulosEnum.RELATORIO_COMPARACAO_VALORES_DADOS_FINANCEIROS,
    PermissoesEnum.ESCRITA
  );
  const readRelatorioComparacaoValoresDadosFinanceiros = checkPermission(
    ModulosEnum.RELATORIO_COMPARACAO_VALORES_DADOS_FINANCEIROS,
    PermissoesEnum.LEITURA
  );

  const checkOpenTab = () => {
    if (editRelatorioMovimentacoes || readRelatorioMovimentacoes) {
      setSelectTab(0);
      return;
    }
    if (editDeclaracaoRecebimento || readRelatorioRecebimentos) {
      setSelectTab(1);
      return;
    }
    if (editRelatorioBoletos || readRelatorioBoletos) {
      setSelectTab(2);
      return;
    }
    if (editRelatorioInadimplencia || readRelatorioInadimplencia) {
      setSelectTab(3);
      return;
    }
    if (editDeclaracaoRecebimento || readDeclaracaoRecebimento) {
      setSelectTab(4);
      return;
    }
    if (
      editRelatorioComparacaoValoresDadosFinanceiros ||
      readRelatorioComparacaoValoresDadosFinanceiros
    ) {
      setSelectTab(5);
      return;
    }
  };
  const [selectTab, setSelectTab] = useState<number>(0); // Inicializa com 0
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isRequest, setIsRequest] = useState<boolean>(false);

  const handleSelectTab = (index: number) => {
    setSelectTab(index);
  };

  useEffect(() => {
    checkOpenTab();
  }, []);

  return (
    <>
      {!isLoading ? (
        <Container>
          <Menu
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <OptionsContainer
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start",
              }}
            >
              <ButtonTab
                onClick={() => {
                  handleSelectTab(0);
                }}
                active={selectTab === 0}
                disabled={
                  isRequest ||
                  !editRelatorioMovimentacoes ||
                  !readRelatorioMovimentacoes
                }
              >
                Relatórios de movimentações
              </ButtonTab>
              <ButtonTab
                onClick={() => {
                  handleSelectTab(1);
                }}
                active={selectTab === 1}
                disabled={
                  isRequest ||
                  !editRelatorioRecebimentos ||
                  !readRelatorioRecebimentos
                }
              >
                Relatório de recebimentos
              </ButtonTab>
              <ButtonTab
                onClick={() => {
                  handleSelectTab(2);
                }}
                active={selectTab === 2}
                disabled={
                  isRequest || !editRelatorioBoletos || !readRelatorioBoletos
                }
              >
                Relatório de boletos enviados por Remessa e pagos no Caixa
              </ButtonTab>
              <ButtonTab
                onClick={() => {
                  handleSelectTab(3);
                }}
                active={selectTab === 3}
                disabled={
                  isRequest ||
                  !editRelatorioInadimplencia ||
                  !readRelatorioInadimplencia
                }
              >
                Relatórios de inadimplência
              </ButtonTab>
              <ButtonTab
                onClick={() => {
                  handleSelectTab(4);
                }}
                active={selectTab === 4}
                disabled={
                  isRequest ||
                  !editDeclaracaoRecebimento ||
                  !readDeclaracaoRecebimento
                }
              >
                Declaração de recebimento de doações voluntária
              </ButtonTab>
              <ButtonTab
                onClick={() => {
                  handleSelectTab(5);
                }}
                active={selectTab === 5}
                disabled={
                  isRequest ||
                  !editRelatorioComparacaoValoresDadosFinanceiros ||
                  !readRelatorioComparacaoValoresDadosFinanceiros
                }
              >
                Relatório de comparação de valores dos dados financeiros
              </ButtonTab>
            </OptionsContainer>
          </Menu>

          <ContainerPages>
            {(() => {
              switch (selectTab) {
                case 0:
                  return <RelatorioMovimentacoes />;
                case 1:
                  return <RelatorioRecebimentos />;
                case 2:
                  return <RelatorioBoletosPagosCaixa />;
                case 3:
                  return <RelatorioInadimplencia />;
                case 4:
                  return <DeclaracaoAnualContribuicaoVoluntaria />;
                case 5:
                  return <RelatorioComparacaoValoresDadosFinanceiros />;
                default:
                  return null;
              }
            })()}
          </ContainerPages>
        </Container>
      ) : (
        <LoadingOverlay>
          <LoadingGif src={loadSCGif} alt="Carregando..." />
        </LoadingOverlay>
      )}
    </>
  );
};

export default RelatoriosGerenciais;
